import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { getCarLocationHistorySharing } from '../operations/getCarLocationHistorySharing';

import { STATUS_LOADING } from 'common/constants';

export const setCarLocationHistorySharing = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(getCarLocationHistorySharing.pending, (state) => {
    state.locationHistorySharing.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getCarLocationHistorySharing.fulfilled, (state, { payload }) => {
    state.locationHistorySharing.loadingStatus = STATUS_LOADING.done;
    state.locationHistorySharing.data = payload;
  })
  .addCase(getCarLocationHistorySharing.rejected, (state) => {
    state.locationHistorySharing.loadingStatus = STATUS_LOADING.error;
  });
